// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import Image from '@tcp/core/src/components/common/atoms/Image';
import withStyles from '../../../../../../common/hoc/withStyles';
import Styles from '../styles/FreeShippingBannerSection.style';
import { labelsHashValuesReplace, convertHtml } from '../../../../LoyaltyBanner/util/utility';
import CONSTANTS from '../../../../Checkout/Checkout.constants';
import { getIconPath } from '../../../../../../../utils';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GlobalAccessibilityLabels,
  GLOBAL_ACCESSIBILITY_LABELS,
  lblFastShipping,
} from '../../../../../../../utils/labels/globalAccessibility.labels';
import {
  BAG_PAGE_LABELS,
  lblFreeShippingBannerLabel,
} from '../../../../BagPage/labels/BagPage.labels';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
  lblDetails,
} from '../../../../../../../utils/labels/globalGeneric.labels';

const FreeShippingBannerSection = (props) => {
  const fastShippingPath = getIconPath('fast-shipping');
  const { className } = props;

  const utilArrShippingNew = [
    {
      key: '#tagOpen#',
      value: `<span class="${className} shippingNew">`,
    },
    {
      key: '#tagClose#',
      value: `</span>`,
    },
  ];
  const labelStr = renderLabel(
    getLabelFromCopyOrFromTranslation(`${BAG_PAGE_LABELS}.${lblFreeShippingBannerLabel}`),
    'lbl_freeShippingBanner_label'
  );
  const convertedStrValue = labelsHashValuesReplace(labelStr, utilArrShippingNew);
  const freeShippingLabel = convertHtml(convertedStrValue);
  const freeShippingLabelExist = freeShippingLabel !== 'lbl_freeShippingBanner_label';

  return (
    freeShippingLabelExist && (
      <div className={`${className}`}>
        <BodyCopy
          className="free-shipping-banner-section-wrapper"
          component="div"
          fontFamily="secondary"
          fontWeight="extrabold"
        >
          <Image
            src={fastShippingPath}
            alt={renderLabel(
              getLabelFromCopyOrFromTranslation(
                `${GLOBAL_ACCESSIBILITY_LABELS}.${lblFastShipping}`,
                GlobalAccessibilityLabels
              ),
              'lbl_fast_shipping'
            )}
            className="fast-shipping"
          />
          {freeShippingLabel}
          <span className="free-shipping-details">
            <Anchor
              className="details"
              anchorVariation="primary"
              text={renderLabel(
                getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_GENERIC_LABELS}.${lblDetails}`,
                  GlobalGenericLabels
                ),
                'lbl_details'
              )}
              url={CONSTANTS.FREE_SHIPPING_URL}
              target="_blank"
              underline
            />
          </span>
        </BodyCopy>
      </div>
    )
  );
};

FreeShippingBannerSection.propTypes = {
  className: PropTypes.string,
};

FreeShippingBannerSection.defaultProps = {
  className: '',
};

export default withStyles(FreeShippingBannerSection, Styles);
export { FreeShippingBannerSection as FreeShippingBannerSectionVanilla };
